import { updater } from "../../utils/updater.js";
import Cookies from "universal-cookie";

const cookies = new Cookies();
/**
 * Cookie API factory.
 *
 */
export function cookieFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const CookieUsage = () => state.CookieUsage;
  const MvcCookie = () => state.MvcCookie;
  const getCookie = (name) => cookies.get(name);
  const setCookies = (name, cookieValue, cookiePath = "/") => {
    cookies.set(name, cookieValue, cookiePath);
    updateState((draft) => {
      draft[name] = cookies.get(name);
    });
  };

  const removeCookies = (name) => {
    cookies.remove(name);
    updateState((draft) => {
      draft[name] = null;
    });
  };

  return {
    setCookies,
    removeCookies,
    CookieUsage,
    MvcCookie,
    getCookie,
  };
}

export default cookieFactory;
